import React from "react";
import useStyles from "./styles";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { Box, Step, StepLabel, Stepper, Typography } from "@mui/material";
import CustomStepIcon from "./CustomStepIcon";
import CustomStepConnector from "./CustomStepConnector";
import moment from "moment";
interface StepType {
  action: string;
  created_at: string;
}


interface ActivityProps {
  clientActivityResponse?: any; // Adjust type as per your requirement
}

const Activity: React.FC<ActivityProps> = ({ clientActivityResponse }) => {
  console.log("clientActivityResponse",clientActivityResponse);
  const classes = useStyles();
  return (
    <>
      <PageTitle title="Activity" />
      <Box sx={{ maxWidth: "100%", padding: "4px 16px" }}>
        <Stepper
          orientation="vertical"
          connector={<CustomStepConnector />} // Use the custom connector
        >
          {clientActivityResponse && clientActivityResponse?.map((step: StepType, index: number) => (
            <Step key={index}  className={classes.stepLabel}>
              <StepLabel StepIconComponent={CustomStepIcon} >
                {step?.action}
              </StepLabel>
              <Typography variant="subtitle2">{moment(step?.created_at).startOf('minute').fromNow()}</Typography>
            </Step>
          ))}
        </Stepper>
      </Box>
    </>
  );
};
export default Activity;
